import { z } from 'zod';

import { MAX_PAGE_SIZE, PAGINATION_DEFAULTS } from '../constants/pagination.js';

export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(PAGINATION_DEFAULTS.page),
  limit: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(PAGINATION_DEFAULTS.limit),
});

export const sortSchema = z.object({
  sort: z.string().optional(),
  order: z.enum(['asc', 'desc']).default('asc'),
});
